import { SHOW_FLASH_MESSAGE, HIDE_FLASH_MESSAGE } from '../action-types';

export const DEFAULT_STATE = {
  message: undefined
};

const showFlashMessage = (state, action) => ({
  ...state,
  message: action.payload.message
});

const hideFlashMessage = (state, action) => ({
  ...state,
  message: undefined
});

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SHOW_FLASH_MESSAGE:
      return showFlashMessage(state, action);
    case HIDE_FLASH_MESSAGE:
      return hideFlashMessage(state, action);
    default:
      return state;
  }
};
